import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '../../Components/Button'
import Input from '../../Components/Input'
import QuizHeader from '../../Components/QuizHeader'
import styles from "./Styles/BasicDetails.module.css"
import sideImage from "../../Assets/project_details.png"
import CustomDropdown from "../../Components/CustomDropdown"
import { HiOutlineChevronDown, HiOutlineChevronUp } from 'react-icons/hi'
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';

export default function ProjectDetails() {
  const navigate = useNavigate()
  const [projectType, setProjectType] = useState('New Office')
  return (
    <React.Fragment>
        <QuizHeader step2 />
        <div className={styles.container}>
        <main>
          <img className={styles.sideImage} src={sideImage} />

          <div className={styles.authForm}>
            <form>
                <h2>Company Details</h2>
                <h3>Provide us with your company details to proceed further.</h3>
                <Input white label="Company Name"  mb={24}/>
                <Input mb={24} white label="Website" />
                <div className={styles.dropdownContainer}>
                  <label>Office Purpose</label>
                <Dropdown
                    placeholder="Select"
                    options={['purpose one','purpose two']}
                    className={styles.dropdownContainer}
                    placeholderClassName={styles.dropdownPlaceholder}
                    arrowClosed={<span><HiOutlineChevronDown color="#1A1A1A" size={14} /></span>}
                    arrowOpen={<span><HiOutlineChevronUp color="#1A1A1A" size={14} /></span>}
                    arrowClassName={styles.dropdownArrow}
                    controlClassName={styles.dropdown}
                    menuClassName={styles.dropdownMenu}
                  />
                </div>
                <Input mb={24} placeholder="Enter your Office Location" white label="Location" />

                <div className={styles.projectTypeContainer}>
                  <h3>Project Type</h3>
                  <div className={styles.projectType}>
                    <div onClick={()=>setProjectType('New Office')} className={projectType == 'New Office' && styles.selectedType}>
                      <span></span>
                      <p>New <br/>Office</p>
                      <h6 className={styles.selection}></h6>
                    </div>
                    <div onClick={()=>setProjectType('Office Renovation')} className={projectType == 'Office Renovation' && styles.selectedType}>
                      <span></span>
                    <p>Office<br /> Renovation</p>
                    <h6 className={styles.selection}></h6>
                    </div>
                  </div>
                </div>

                <Button height={56} onClickHandler={()=>navigate('/quiz/designstyle')} radius={10} mt={32} title="Continue" />
            </form>
        </div>
        </main>
      </div>
    </React.Fragment>
  )
}
